export const cleanQueryParams = (queryParams: {
    [key: string]: string | string[] | undefined;
}) => {
    const cleanedParams: { [key: string]: string | string[] } = {};
    Object.keys(queryParams).forEach((key) => {
        const value = queryParams[key];
        if (value !== undefined && value !== '' && key !== 'search-path') {
            cleanedParams[key] = value;
        }
    });
    return cleanedParams;
};
